export default "https://assets.egbcdn.net/assets/packs/_/images/crypto-logotypes/ethereum-eth-logo-a1540a6755943de1af8294b1e32b6ef6.png";